forms-orders-files-destroy
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }" enctype="multipart/form-data")
    .row
      .col-md-4
        label { opts.label }
      .col-md-8
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
        .file-wrap.d-flex(each="{ item, index in opts.inputs.files }")
          a.btn.btn-sm.btn-primary.mb-2.mr-2(href="{item.url}" target="_blank" class="ml-2")
            i.fa.fa-download
          input.mr-2(type="checkbox" id="{this.tagScope}.file_{index}" name="ids[]" value="{ item.id }" onClick="{ this.onClick }")
          label.pt-2(for="{this.tagScope}.file_{index}") { item.filename }
    div(if="{hasChecked}")
      inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
    script(type="typescript").
      this.mixin('forms.orders.files.destroy');